export default "__VITE_ASSET__535f6d88__"